import gql from 'graphql-tag'
import { mapGetters } from 'vuex';
import commitmentProgessQuery from '../graphql/queries/commitmentProgressQuery.gql'
import Glossary from '../mixins/Glossary'

export default {
	data: () => ({
		answers: [],
		intervalOptions: [
			{
				'label': '12 Months',
				'value': 12
			},
			{
				'label': '24 Months',
				'value': 24
			},
			{
				'label': '36 Months',
				'value': 36
			},
		],
		commitmentProgress: [],
		commitment_answers: [],
		actionTargetAnswers: [],
		actionBaselineAnswers: [],
		notification_interval: 12,
		proof: null,
		existingProofId: null,
		valid: true,
		definitionValid: true
	}),
	apollo: {
		commitmentProgress: {
			query: commitmentProgessQuery,
			variables() {
				return {
					city_id: this.me.cities[0].id
				}
			},
			skip() {
				return !this.me.cities
			},
			update: data => data.cityCommitmentProgress
		},
	},
	methods: {

		//Initialize arrays for multiselect inputs
		initializeAnswerArrays() {
			if (this.activeActionCommitmentStep && this.activeActionCommitmentStep.commitment_targets[0]) {
				const target = this.activeActionCommitmentStep.commitment_targets[0];

				// Initialize target answers
				if (target.target_questions) {
					target.target_questions.forEach((question, index) => {
						if (question.input_type === "multiselect" && (!this.actionTargetAnswers[index] || !Array.isArray(this.actionTargetAnswers[index]))) {
							this.$set(this.actionTargetAnswers, index, []);
						}
					});
				}

				// Initialize baseline answers
				if (target.baseline_questions) {
					target.baseline_questions.forEach((question, index) => {
						if (question.input_type === "multiselect" && (!this.actionBaselineAnswers[index] || !Array.isArray(this.actionBaselineAnswers[index]))) {
							this.$set(this.actionBaselineAnswers, index, []);
						}
					});
				}
			}
		},
		
		//Theme
		selectTheme(theme) {
			this.$store.commit('setMakeCommitmentSelectedTheme', theme)
		},

		unselectTheme() {
			this.$store.commit('setMakeCommitmentSelectedTheme', null)
		},

		//Commitments
		selectCommitment(commitment) {
			this.$store.commit('setMakeCommitmentSelectedCommitment', commitment)
		},

		//Update a commitment action definition
		updateCommitmentActionDefinition(action_id, target_id) {
			console.log('Updating definition')
			this.definitionValid = true
			
			//Validate definition
			if (!this.commitment_answers[target_id]) {
				this.definitionValid = false
			}

			if (this.definitionValid) {
				this.$apollo.mutate({
					mutation: gql`mutation (
							$id: Int!,
							$commitment_answer: String!
						) {
						updateCommitmentAction(
							id: $id
							commitment_answer: $commitment_answer,
						) {
							id
						}
					}`,
					variables: {
						id: action_id,
						commitment_answer: this.commitment_answers[target_id],
					},
				}).then((data) => {
					// this.$store.dispatch('attempt');
					// this.editingItemDate = null
					this.editCommitmentDefinition = false
					alert('Your target has been updated')
					this.$store.dispatch('attempt')
				}).catch((error) => {
					console.error(error)
				})
			}
		},

		createCommitmentActionDefinition(target_id) {
			console.log('Creating definition')
			this.definitionValid = true
			
			//Validate definition
			if (!this.commitment_answers[target_id]) {
				this.definitionValid = false
			}
			
			if (this.definitionValid) {
				this.$apollo.mutate({
					mutation: gql`mutation (
						$target_id: ID!
						$city_id: ID!
						$commitment_id: ID!
						$commitment_answer: String,
					) {
					createCommitmentAction(
						input: {
							completion_value: 0
							target: { connect: $target_id }
							city: { connect: $city_id }
							commitment: { connect: $commitment_id }
							commitment_answer: $commitment_answer
							notification_interval: 6
						}
					) {
						id
						commitment_answer
					}
				}`,
					variables: {
						target_id: target_id,
						city_id: this.me.cities[0].id,
						commitment_id: this.$store.state.actionStore.activeActionCommitment.id,
						commitment_answer: this.commitment_answers[target_id]
					},
				}).then((data) => {
					alert('Your target has been created')
					this.$store.dispatch('attempt')
				}).catch((error) => {
					console.error(error)
				})
			}
		},

		//Create a new target action
		createCommitmentActionAnswers() {
			console.log('Creating answers')
			this.valid = true
			
			//Only validate if any answers are set, it should be possible to not set them
			if (this.actionBaselineAnswers.length) {
				if (this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].baseline_questions && this.actionBaselineAnswers.length != this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].baseline_questions.length) {
					this.valid = false
				}
			}
			//Only validate if any answers are set, it should be possible to not set them
			if (this.actionTargetAnswers.length) {
				if (this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].target_questions && this.actionTargetAnswers.length != this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].target_questions.length) {
					this.valid = false
				}
			}

			//Validate notification interval
			if (!this.notification_interval) {
				this.valid = false
			}

			//Ensure multiselect array answers are converted to comma seperated stings
			this.actionTargetAnswers = this.actionTargetAnswers.map(answer => Array.isArray(answer) ? answer.join(',') : answer);
			this.actionBaselineAnswers = this.actionBaselineAnswers.map(answer => Array.isArray(answer) ? answer.join(',') : answer);

			if (this.valid) {
				this.$apollo.mutate({
					mutation: gql`mutation (
							$target_id: ID!
							$city_id: ID!
							$commitment_id: ID!
							$target_answers: [String]
							$baseline_answers: [String]
							$notification_interval: Int!
							$proof: [MediaInput]
							$existing_proof_id: Int
						) {
						createCommitmentAction(
							input: {
								completion_value: 0
								target: { connect: $target_id }
								city: { connect: $city_id }
								commitment: { connect: $commitment_id }
								target_answers: $target_answers
								baseline_answers: $baseline_answers
								notification_interval: $notification_interval
								proof: $proof
								existing_proof_id: $existing_proof_id
							}
						) {
							id
						}
					}`,
					variables: {
						target_id: this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].id,
						city_id: this.me.cities[0].id,
						commitment_id: this.$store.state.actionStore.activeActionCommitment.id,
						target_answers: this.actionTargetAnswers,
						baseline_answers: this.actionBaselineAnswers,
						notification_interval: this.notification_interval,
						proof: this.proof,
						existing_proof_id: this.existingProofId,
					},
				}).then((data) => {
					// this.$emit('showSuccessModal')
					alert('Your target has been saved')
					this.$store.dispatch('attempt')
					this.actionTargetAnswers = []
					this.actionBaselineAnswers = []
					this.proof = null
				}).catch((error) => {
					console.error(error)
				})
			}
			
		},

		//Update a target action
		updateCommitmentAction(ActionId) {
			console.log('Updating answers')
			this.valid = true

			//Only validate if any answers are set, it should be possible to not set them
			if (this.actionBaselineAnswers.length) {
				if (this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].baseline_questions && this.actionBaselineAnswers.length != this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].baseline_questions.length) {
					this.valid = false
				}
			}
			//Only validate if any answers are set, it should be possible to not set them
			if (this.actionTargetAnswers.length) {
				if (this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].target_questions && this.actionTargetAnswers.length != this.$store.state.actionStore.activeActionCommitmentStep.commitment_targets[0].target_questions.length) {
					this.valid = false
				}
			}


			//Validate notification interval
			if (!this.notification_interval) {
				this.valid = false
			}
			

			if (this.valid) {
					this.$apollo.mutate({
						mutation: gql`mutation (
								$id: Int!,
								$baseline_answers: [String],
								$target_answers: [String],
								$notification_interval: Int!
								$proof: [MediaInput]
								$existing_proof_id: Int
							) {
							updateCommitmentAction(
								id: $id
								baseline_answers: $baseline_answers
								target_answers: $target_answers
								notification_interval: $notification_interval
								proof: $proof
								existing_proof_id: $existing_proof_id
							) {
								id
							}
						}`,
						variables: {
							id: ActionId,
							target_answers: this.actionTargetAnswers,
							baseline_answers: this.actionBaselineAnswers,
							notification_interval: this.notification_interval,
							proof: this.proof,
							existing_proof_id: this.existingProofId,
						},
					}).then((data) => {
						this.$store.dispatch('attempt');
						alert('Your target has been updated')
						this.actionTargetAnswers = []
						this.actionBaselineAnswers = []
						this.proof = null
					}).catch((error) => {
						console.error(error)
					})
					
			}
			



			
		},

		//Update a target action answers only
		updateCommitmentActionAnswers(id, data, requiredLength) {
			console.log('updateCommitmentActionAnswers')
			this.valid = true
			console.log(data, requiredLength)
			//Validate notification interval
			if (typeof data === 'undefined' || data.length != requiredLength) {
				this.valid = false
			}

			if (this.valid) {
				this.$apollo.mutate({
					mutation: gql`mutation (
							$id: Int!,
							$target_answers: [String],
							$proof: [MediaInput]
						) {
						updateCommitmentAction(
							id: $id
							target_answers: $target_answers
							proof: $proof
						) {
							id
						}
					}`,
					variables: {
						id: id,
						target_answers: data,
						proof: this.proof,
					},
				}).then((data) => {
					this.$store.dispatch('attempt');
					this.editingItem = null
					alert('Your target has been updated')
					this.actionTargetAnswers = []
					this.actionBaselineAnswers = []
					this.proof = null
				}).catch((error) => {
					console.error(error)
				})
			}
			
		},

		updateCommitmentActionNotificationPeriod(actionId, newInterval) {
			console.log('Updating notification period')
			this.$apollo.mutate({
				mutation: gql`mutation (
						$id: Int!,
						$notification_interval: Int!,
					) {
					updateCommitmentAction(
						id: $id
						notification_interval: $notification_interval
					) {
						id
					}
				}`,
				variables: {
					id: actionId,
					notification_interval: newInterval
				},
			}).then((data) => {
				this.$store.dispatch('attempt');
				this.editingItemDate = null
				alert('Your notification interval has been updated')
			}).catch((error) => {
				console.error(error)
			})
		},

		//update Action
		updateBaselineActionAnswers(id, data, requiredLength) {
			this.valid = true

			//Validate notification interval
			if (typeof data === 'undefined' || data.length != requiredLength) {
				this.valid = false
			}

			if (this.valid) {
				this.$apollo.mutate({
					mutation: gql`mutation (
							$id: Int!,
							$baseline_answers: [String],
						) {
						updateCommitmentAction(
							id: $id
							baseline_answers: $baseline_answers
						) {
							id
						}
					}`,
					variables: {
						id: id,
						baseline_answers: data,
						proof: this.proof,
					},
				}).then((data) => {
					this.$store.dispatch('attempt');
					this.editingItem = null
					alert('Your target has been updated')
					this.actionTargetAnswers = []
					this.actionBaselineAnswers = []
					this.proof = null
				}).catch((error) => {
					console.error(error)
				})
			}
			
		},

		//create a new action
		createNewActionUpdate(data, requiredLength, action) {
			this.valid = true
			console.log(data)
			console.log(requiredLength)
			//Validate notification interval
			if (data.length != requiredLength) {
				this.valid = false
			}

			if (this.valid) {

				this.$apollo.mutate({
					mutation: gql`mutation (
							$action_id: Int!
							$target_answers: [String],
							$proof: [MediaInput]
						) {
						createCommitmentActionUpdate(
							input: {
								commitment_actions_id: $action_id
								target_answers: $target_answers
								proof: $proof
							}
						) {
							id
						}
					}`,
					variables: {
						action_id: action.id,
						target_answers: data,
						proof: this.proof
					},
				}).then((data) => {
					this.$store.dispatch('attempt')
					this.creatingReport = false
					this.actionTargetAnswers = []
					this.actionBaselineAnswers = []
					this.proof = null
				}).catch((error) => {
					console.error(error)
				})
			}

			
		},

		hydrateDescription(description) {
			return description.replace('<city>', this.me.cities[0].name)
		},

		getMyThemeProgressPercentage(themeId, totalThemeSteps) {
			return this.getMyThemeProgressSteps(themeId) / totalThemeSteps * 100
		},

		getMyProgressPercentage(commitmentId, includeCommitment = true) {
			var progress = 0;

			this.commitmentProgress.forEach(commitment => {
				if (commitment.commitment_id == commitmentId) {
					progress = commitment.percentage
				}
			})

			//if no target progress, check to see if they have commited to a commitment, which will count as 10%
			if (progress == 0 && includeCommitment) {
				this.me.cities[0].commitments.forEach(commitment => {
					if (commitment.id == commitmentId) {
						progress = 10
					}
				})
			}

			return progress
		},

		getMyProgressSteps(commitmentId) {
			var progress = 0;

			this.commitmentProgress.forEach(commitment => {
				if (commitment.commitment_id == commitmentId) {
					progress = commitment.completed_steps + ' out of ' + commitment.total_steps
				}
			})

			return progress
		},

		//Get users commitment actions based on a targte ID optionally specify the requires paramater to check for baseline or target answers
		getMyCommitmentActionByTargetId(target_id, requires) {
			var result = this.me.cities[0].commitment_actions.filter(action => {
				return action.target.id === target_id
			})
			
			if (!result.length) {
				return {}
			}

			if (requires == 'baseline' && !result[0].baseline_answers) {
				return {}
			}

			if (requires == 'target' && !result[0].target_answers) {
				return {}
			}
			
			return result[0];
		},

		//Get users target answers by target ID
		myTargetAnswerForTarget(target_id) {
			var result = this.me.cities[0].commitment_actions.filter(action => {
				return action.target.id === target_id
			})
			
			if (!result.length || !result[0].baseline_answers) {
				return {}
			}
			
			return result[0];
		},

		//Check if currently logged in user has made a commitment by commitment id
		commitmentMade(commitmentId) {
			return this.me.cities[0].commitments.filter(commitment => commitment.id === commitmentId).length > 0
		},

		isTargetAcheived(target_id) {
			var result = this.me.cities[0].commitment_actions.filter(action => {
				if (action.target.id === target_id) {
					return action.target_answers != null
				}
				return false
			})
			
			return result.length
		},

		myCommitmentsByTheme(id) {
			return this.commitmentProgress.filter(item => {
				return item.commitment.theme.id == id && this.getMyProgressPercentage(item.commitment.id) > 0
			})
		},	

		hydrateTargetAnswer(target, answers) {
			if (answers) {
				answers.forEach((answer, index) => {
					var counter = index + 1
					target = target.replace('<' + counter + '>', '<strong>' + answer + '</strong>')
				})
			}

			return target
		},

		commitmentQuestionLabel(label) {
			if (label) {
				 return label
			}
			return "Describe in the box below how your city is taking action."
		},

		saveCommitmentQuestionAndNext(commitment_step) {
			this.saveCommitmentQuestion(commitment_step.commitment_targets[0].id)
			this.selectCommitmentStep(commitment_step)
		},

		updateTargetAnswers(index, val) {
			console.log('updateTargetAnswers')
			this.actionTargetAnswers[index] = val
		},

		updateBaselineAnswers(val) {
			this.actionBaselineAnswers = val
		},

		onProofChange(media) {
			this.proof = this.convertToMediaSchema(media)
		},

		setActiveTheme(theme, updateUrl) {
			this.$store.commit('setActiveActionTheme', theme)

			if (!this.activeActionCommitment) {
				this.selectCommitment(theme.commitments[0], true)
			}
			
			//Update the URL
			if (updateUrl) {
				history.pushState(null, null, `${window.location.origin}/commitments/theme-${theme.id}/commitment-${this.activeActionCommitment.id}`);
			}
		},

		selectCommitment(commitment, updateUrl) {
			this.$store.commit('setDisplayInfoFor', 'commitment')
			this.$store.commit('setActiveActionCommitment', commitment)

			//Update the URL
			if (updateUrl) {
				history.pushState(null, null, `${window.location.origin}/commitments/theme-${this.activeActionTheme.id}/commitment-${commitment.id}`);
			}

			//Scroll to content
			const element = this.$refs.content
			if (element) {
				const top = element.offsetTop;
				window.scrollTo(0, top + 100);
			}

			//reset models
			this.actionTargetAnswers = []
			this.actionBaselineAnswers = []
			this.proof = null
			this.existingProofId = null
			this.activeTab = 'details'

			// Initialize arrays for multiselect inputs
			this.$nextTick(() => {
				this.initializeAnswerArrays()
			})
		},
	},
	computed: {
		...mapGetters({
			me: 'getMe',
			authenticated: 'authenticated',
			activeActionTheme: 'getActiveActionTheme',
			activeActionCommitment: 'getActiveActionCommitment',
			activeActionCommitmentStep: 'getActiveActionCommitmentStep',
			displayInfoFor: 'getDisplayInfoFor',
		}),
		
		hydrateTargetQuestion() {	
			var html = '<p>'

			html = html + this.activeActionCommitmentStep.commitment_targets[0].target

			if (this.activeActionCommitmentStep.commitment_targets[0].target_questions) {
				this.activeActionCommitmentStep.commitment_targets[0].target_questions.forEach((questionData, index) => {
					var counter = index + 1,
						placeholder

					if (typeof questionData.placeholder_text === 'undefined' || !questionData.placeholder_text || questionData.placeholder_text === null) {
						placeholder = 'Enter value'
					}
					else {
						placeholder = questionData.placeholder_text
					}

					switch (questionData.input_type) {
						case "select":
							html = html.replace('<' + counter + '>', `<select class="c-input-inline-select mx-1" v-model="proxyValue[${index}]"><option v-for="(option, index) in questionData[${index}].options.split(',')" :key="index" :value="option">{{option}}</option></select>`)
							break;
						case "multiselect":
							html = html.replace('<' + counter + '>', `
								<span class="c-input-inline-multiselect">
									<span @click="toggleMultiSelect(${index})" class="c-input-inline-multiselect__label">Choose multiple</span>
									<select v-if="activeMultuSelect === ${index}" class="c-input-inline-multiselect__select mx-1" v-model="proxyValue[${index}]" multiple>
										<option v-for="(option, index) in questionData[${index}].options.split(',')" :key="index" :value="option">{{option}}</option>
									</select>
								</span>
							`)
							break;
						case "text":
							html = html.replace('<' + counter + '>', `<input class="c-inline-input" type="text" v-model="proxyValue[${index}]" placeholder="${placeholder}" />`)
						case "textarea":
							html = html.replace('<' + counter + '>', `<textarea class="d-block w-100" type="text" v-model="proxyValue[${index}]" placeholder="${placeholder}"></textarea>`)
						default:
							break;
					}
					
				})
			}

			html = this.glossaryHydrate(html) + '</p>'

			return {
				template: html,
				data: () => ({
					questionData: this.activeActionCommitmentStep.commitment_targets[0].target_questions,
					activeMultuSelect: null
				}),
				props: {
					value: {
						required: true
					}
				},
				created() {
					// Initialize array values for multiselect inputs
					if (this.activeActionCommitmentStep && this.activeActionCommitmentStep.commitment_targets[0].target_questions) {
						this.activeActionCommitmentStep.commitment_targets[0].target_questions.forEach((question, index) => {
							if (question.input_type === "multiselect" && (!this.value[index] || !Array.isArray(this.value[index]))) {
								// Create a reactive array for multiselect inputs if not already an array
								this.$emit('input', {...this.value, [index]: []});
							}
						});
					}
				},
				mounted() {
					document.addEventListener('click', this.handleClickOutside);
				},
				beforeDestroy() {
					document.removeEventListener('click', this.handleClickOutside);
				},
				methods: {
					toggleMultiSelect(index) {
						this.activeMultuSelect = this.activeMultuSelect === index ? null : index;
					},
					handleClickOutside(event) {
						// Only close if open
						if (this.activeMultuSelect !== null) {
							// Find the multiselect element
							const multiselect = this.$el.querySelector('.c-input-inline-multiselect__select');
							if (multiselect && !multiselect.contains(event.target)) {
								// Also check the label span
								const label = this.$el.querySelector('.c-input-inline-multiselect__label');
								if (!label.contains(event.target)) {
									this.activeMultuSelect = null;
								}
							}
						}
					}
				},
				computed: {
					proxyValue: {
					  get() { return this.value; },
					  set(newValue) { this.$emit('input', newValue); }
					}
				}
			}
		},

		hydrateBaselineQuestion() {
			var html = '<p>'
			
			html = html + this.activeActionCommitmentStep.commitment_targets[0].baseline

			if (this.activeActionCommitmentStep.commitment_targets[0].baseline_questions) {
				this.activeActionCommitmentStep.commitment_targets[0].baseline_questions.forEach((questionData, index) => {
					var counter = index + 1,
						placeholder

					if (typeof questionData.placeholder_text === 'undefined' || !questionData.placeholder_text || questionData.placeholder_text === null) {
						placeholder = 'Enter value'
					}
					else {
						placeholder = questionData.placeholder_text
					}
					
					switch (questionData.input_type) {
						case "select":
							html = html.replace('<' + counter + '>', `<select class="c-input-inline-select mx-1" v-model="proxyValue[${index}]"><option v-for="(option, index) in componentQuestionData[${index}].options.split(',')" :key="index" :value="option">{{option}}</option></select>`)
							break;
						case "multiselect":
							html = html.replace('<' + counter + '>', `
								<span class="c-input-inline-multiselect">
									<span @click="toggleMultiSelect(${index})" class="c-input-inline-multiselect__label">Choose multiple</span>
									<select v-if="activeMultuSelect === ${index}" class="c-input-inline-multiselect__select mx-1" v-model="proxyValue[${index}]" multiple>
										<option v-for="(option, index) in componentQuestionData[${index}].options.split(',')" :key="index" :value="option">{{option}}</option>
									</select>
								</span>
							`)
							break;
						case "text":
							html = html.replace('<' + counter + '>', `<input class="c-inline-input" type="text" v-model="proxyValue[${index}]" placeholder="${placeholder}" />`)
						case "textarea":
							html = html.replace('<' + counter + '>', `<textarea class="d-block w-100" type="text" v-model="proxyValue[${index}]" placeholder="${placeholder}"></textarea>`)
						default:
							break;
					}
				})
			}

			html = this.glossaryHydrate(html) + '</p>'

			return {
				template: html,
				data: () => ({
					componentQuestionData: this.activeActionCommitmentStep.commitment_targets[0].baseline_questions,
					activeMultuSelect: null
				}),
				props: {
					value: {
						required: true
					}
				},
				created() {
					// Initialize array values for multiselect inputs
					if (this.activeActionCommitmentStep && this.activeActionCommitmentStep.commitment_targets[0].baseline_questions) {
						this.activeActionCommitmentStep.commitment_targets[0].baseline_questions.forEach((question, index) => {
							if (question.input_type === "multiselect" && (!this.value[index] || !Array.isArray(this.value[index]))) {
								this.$emit('input', {...this.value, [index]: []});
							}
						});
					}
				},
				mounted() {
					document.addEventListener('click', this.handleClickOutside);
				},
				beforeDestroy() {
					document.removeEventListener('click', this.handleClickOutside);
				},
				methods: {
					toggleMultiSelect(index) {
						this.activeMultuSelect = this.activeMultuSelect === index ? null : index;
					},
					handleClickOutside(event) {
						if (this.activeMultuSelect !== null) {
							const multiselect = this.$el.querySelector('.c-input-inline-multiselect__select');
							if (multiselect && !multiselect.contains(event.target)) {
								const label = this.$el.querySelector('.c-input-inline-multiselect__label');
								if (!label.contains(event.target)) {
									this.activeMultuSelect = null;
								}
							}
						}
					}
				},
				computed: {
					proxyValue: {
					  get() { return this.value; },
					  set(newValue) { this.$emit('input', newValue); }
					}
				}
			}
		},

		hydrateReportQuestion() {	
			var html = '<p>'

			html = html + this.activeActionCommitmentStep.commitment_targets[0].report

			if (this.activeActionCommitmentStep.commitment_targets[0].report_questions) {
				this.activeActionCommitmentStep.commitment_targets[0].report_questions.forEach((questionData, index) => {
					var counter = index + 1,
						placeholder

					if (typeof questionData.placeholder_text === 'undefined' || !questionData.placeholder_text || questionData.placeholder_text === null) {
						placeholder = 'Enter value'
					}
					else {
						placeholder = questionData.placeholder_text
					}

					switch (questionData.input_type) {
						case "select":
							html = html.replace('<' + counter + '>', '<input-inline-select v-model="targetAnswers[' + index + ']" :data="questionData[' + index + ']"></input-inline-select>')
							break;
						case "multiselect":
							html = html.replace('<' + counter + '>', `<select class="c-input-inline-select mx-1" v-model="proxyValue[${index}]" multiple><option v-for="(option, index) in componentQuestionData[${index}].options.split(',')" :key="index" :value="option">{{option}}</option></select>`)
							break;
						case "text":
							html = html.replace('<' + counter + '>', '<input class="c-inline-input" type="text" v-model="targetAnswers[' + index + ']" placeholder="' + placeholder + '" />')
						case "textarea":
							html = html.replace('<' + counter + '>', `<textarea class="w-100 d-block" type="text" v-model="proxyValue[${index}]" placeholder="${placeholder}"></textarea>`)
						default:
							break;
					}
					
				})
			}

			html = this.glossaryHydrate(html) + '</p>'

			return {
				template: html,
				data: () => ({
					questionData: this.activeActionCommitmentStep.commitment_targets[0].report_questions,
					targetAnswers: []
				}),
				props: {
					value: {
						type: Array
					}
				},
				created() {
					// Initialize array values for multiselect inputs
					if (this.activeActionCommitmentStep && this.activeActionCommitmentStep.commitment_targets[0].report_questions) {
						this.activeActionCommitmentStep.commitment_targets[0].report_questions.forEach((question, index) => {
							if (question.input_type === "multiselect" && (!this.proxyValue || !this.proxyValue[index] || !Array.isArray(this.proxyValue[index]))) {
								// Initialize proxyValue array for multiselect inputs
								if (!this.proxyValue) {
									this.proxyValue = [];
								}
								this.$set(this.proxyValue, index, []);
							}
						});
					}
				},
				computed: {
					proxyValue: {
					  get() { return this.value; },
					  set(newValue) { this.$emit('input', newValue); }
					}
				},
				watch: {
					targetAnswers (val) {
						this.$emit('input', val);
					},
				},
			}
		},
	},
	mixins: [Glossary]
}